import { defineStore, skipHydrate } from "pinia";
import type { ILocationCity, IMainLocation } from "~/types/region";
import { useApi } from "~~/lib";
import { useMainStore } from "./mainState";
import { clone, cloneDeep } from "lodash-es";
import { useSessionStorage } from "@vueuse/core";

export const useRegionStore = defineStore('region', () => {

    const api = useApi();
    const mainStore = useMainStore();

    const awaitingGeo = ref(true);
    const geoNoted = useSessionStorage('geo-noted', false);

    async function setCity(id: number) {
        try {
            const data = await api.request<IMainLocation>('/rest/geo/set-city', {
                id
            });

            if (data && mainStore.location) {
                updateCity(data, false);
            }

        } catch {}
    }

    async function useCoords(longitude: number, latitude: number)
    {
        try {
            const data = await api.request<IMainLocation>('/rest/geo/try-coords', {
                lon: longitude,
                lat: latitude,
            });

            if (data && mainStore.location) {
                updateCity(data, true);
            }

        } catch {} finally {
            awaitingGeo.value = false;
        }
    }

    function updateCity(location: IMainLocation, sendNoty: boolean)
    {
        const shouldReload = mainStore.location!.city.content !== location.city.content;

        if (mainStore.location!.city.id !== location.city.id) {
            // @ts-ignore
            if (sendNoty) {
                useNuxtApp().$event('auto-set-city', location);
            }
            mainStore.location!.city = cloneDeep(location.city);
        }

        if (shouldReload) {
            mainStore.init();
        }
    }

    return { setCity, useCoords, awaitingGeo, geoNoted };
});

